const bannerData = [
  {
    image: "banner1.jpg",
  },
  {
    image: "banner2.jpg",
  },
  {
    image: "banner3.jpg",
  },
];

export default bannerData;
